// extracted by mini-css-extract-plugin
export default {"card":"testimonialcard_card__kX4R3","profile":"testimonialcard_profile__0Cm2z","profileName":"testimonialcard_profileName__uCbYp"};